import { AlertCircle } from '@untitled-ui/icons-react';

import { trackError } from '../error/tracking';
import { captureException } from '../logger/capture-exception';
import { openHelpScoutChat } from '../services/helpscout';
import { getStores } from '../services/storage';
import { tGlobal, tNamespace } from '../services/translation';
import { Button } from './buttons/button';
import { FeaturedIcon } from './featured-icon';

// TODO: tests are failing! why?!
const t = tNamespace != null ? tNamespace('app.errorScreen') : (str: string) => str;

export function ErrorScreen(props: { error: unknown }) {
  // TODO: investigate if we actually have captured already
  if (props.error != null) {
    captureException(
      props.error,
      {
        file: 'error-screen.tsx',
        method: 'ErrorScreen',
        infoMessage: 'unknown error coming to screen',
      },
      trackError
    );
  }

  return (
    <div className="flex h-screen max-h-full w-screen max-w-full items-center justify-center">
      <div className="flex flex-col items-center justify-center">
        <FeaturedIcon icon={<AlertCircle />} color="red" size="md" border={false} />
        <h1 className="font-display-2 mb-1 mt-8">{t('error')}</h1>
        <p className="font-body-1-r text-branding-gray">{t('errorDescription')}</p>
        <div className="mt-8 flex gap-4">
          <Button
            size="md"
            variant="accent"
            className="support-chat-button"
            onClick={function () {
              openHelpScoutChat().catch(function (err) {
                captureException(
                  err,
                  {
                    file: 'components/error-screen.tsx',
                    method: 'contactSupport',
                    infoMessage: 'Failed to open HelpScout chat',
                  },
                  trackError
                );
              });
            }}
          >
            {tGlobal('contactSupport')}
          </Button>
          <Button
            size="md"
            variant="outline"
            onClick={function () {
              getStores()
                .users.getState()
                .signOut()
                .catch(function (err) {
                  captureException(
                    err,
                    {
                      file: 'error-screen.tsx',
                      method: 'signOut',
                      infoMessage: 'unable to sign out',
                    },
                    trackError
                  );
                });
            }}
          >
            {tGlobal('logout')}
          </Button>
        </div>
      </div>
    </div>
  );
}
